import { useMutation } from "@tanstack/react-query"
import axios, { AxiosProgressEvent } from "axios"

interface S3UploadParams {
  file: File
  presignedUrl: {
    url: string
    fields: {
      key: string
      AWSAccessKeyId: string
      policy: string
      signature: string
    }
  }
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
}

export const useS3UploadMutation = () => {
  return useMutation<void, Error, S3UploadParams>({
    mutationFn: async ({ file, presignedUrl, onUploadProgress }) => {
      const formData = new FormData()

      // Append all presigned URL fields first (order matters for S3)
      formData.append("key", presignedUrl.fields.key)
      formData.append("AWSAccessKeyId", presignedUrl.fields.AWSAccessKeyId)
      formData.append("policy", presignedUrl.fields.policy)
      formData.append("signature", presignedUrl.fields.signature)

      // Append the file last
      formData.append("file", file)

      await axios.post(presignedUrl.url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        // Don't use axios baseURL for S3 uploads
        baseURL: "",
        onUploadProgress,
      })
    },
  })
}
